// Swish App2App return helpers (V6.2.3). The nonce never goes to console or analytics.

// Swish appends `result` with `?` even when the callback URL already has a query
// (`...&n=X?result=...`). Treat every later `?` as `&` so params stay readable.
export function parseReturnQuery(search) {
  const raw = (search || '').replace(/^\?/, '').replace(/\?/g, '&');
  return new URLSearchParams(raw);
}

const cleanSegment = (v) => (v ? String(v).split(/[?&#]/)[0] : null);

export function readSwishReturn(routeParams, search) {
  const q = parseReturnQuery(search);
  return {
    paymentId: cleanSegment(routeParams?.paymentId || q.get('payment_id')),
    nonce: cleanSegment(routeParams?.nonce || q.get('n')),
    payee: cleanSegment(routeParams?.payee || q.get('payee')),
    result: q.get('result'),
    requestId: q.get('request_id'),
    legacyStatus: q.get('status'),
  };
}

export function decodeResult(result) {
  if (!result) return result;
  try {
    return result.includes('%') ? decodeURIComponent(result) : result;
  } catch {
    return result;
  }
}

const SECRET_KEYS = new Set(['n', 'nonce', 'token', 'access_token']);

export function redactedReturnParams(info) {
  const q = parseReturnQuery(window.location.search);
  const out = {};
  q.forEach((v, k) => { out[k] = SECRET_KEYS.has(k.toLowerCase()) ? '[redacted]' : String(v).slice(0, 500); });
  if (info.paymentId) out.payment_id = info.paymentId;
  if (info.payee) out.payee = info.payee;
  out.path = window.location.pathname.replace(info.nonce || '\u0000', '[redacted]');
  return out;
}

export function suspiciousReason(layers) {
  const list = (layers || []).map((m) => (typeof m === 'string' ? m : m?.layer));
  if (list.includes('payee')) return 'payee';
  if (list.includes('amount')) return 'amount';
  return 'other';
}

// FastAPI 422 returns detail as an array of objects; rendering it as a toast child crashes React.
export function apiErrorMessage(e, fallback) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join('. ') || fallback;
  if (detail && typeof detail.message === 'string') return detail.message;
  return fallback;
}
